var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",attrs:{"no-body":""}},[_c('b-card-body',[_c('h5',{staticClass:"font-size-15 mb-1"},[_c('span',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.location.name))])]),_c('p',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.formatAddress(_vm.location)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }